import type { ReactNode } from "react";

export function ProgressBar({ pct, barClass = "bg-ink", trackClass = "bg-track", h = 4 }:
  { pct: number; barClass?: string; trackClass?: string; h?: number }) {
  const clampedPct = Math.min(100, Math.max(0, pct));
  return (
    <div role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(clampedPct)}
      className={`w-full rounded-full ${trackClass}`} style={{ height: h }}>
      <div data-testid="bar-fill" className={`rounded-full ${barClass}`}
        style={{ width: `${clampedPct}%`, height: h, transition: "width .3s ease" }} />
    </div>);
}

export function PrimaryButton({ children, dark = true, onClick, disabled = false, className = "" }:
  { children: ReactNode; dark?: boolean; onClick?: () => void; disabled?: boolean; className?: string }) {
  return (
    <button onClick={onClick} disabled={disabled}
      className={`w-full rounded-full py-4 text-[16px] font-bold ${disabled ? "opacity-45 cursor-default" : "cursor-pointer"} ${
        dark ? "bg-ink text-cream" : "bg-cream text-ink"} ${className}`}>{children}</button>);
}

export function Toggle({ on, onChange, trackOnClass = "bg-ink", knobOnClass = "bg-cream" }: { on: boolean; onChange?: (v: boolean) => void; trackOnClass?: string; knobOnClass?: string }) {
  return (
    <button role="switch" aria-checked={on} onClick={() => onChange?.(!on)}
      className={`w-11 h-[26px] rounded-full p-[3px] flex items-center box-border cursor-pointer ${(
        on ? trackOnClass + " justify-end" : "bg-track justify-start")}`}>
      <div className={`w-5 h-5 rounded-full ${on ? knobOnClass : "bg-white"}`} />
    </button>);
}

export function Chip({ children, active, danger, onClick }:
  { children: ReactNode; active?: boolean; danger?: boolean; onClick?: () => void }) {
  return (
    <button type="button" onClick={onClick}
      className={`text-[13px] font-medium rounded-full px-3.5 py-[7px] cursor-pointer ${
        active ? "bg-ink text-cream"
        : danger ? "text-accent-deep bg-accent-bg border border-accent-line"
        : "text-ink border border-line bg-white"}`}>{children}</button>);
}

export function SectionLabel({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`font-grotesk text-[11px] font-semibold tracking-[.14em] text-ink4 ${className}`}>{children}</div>;
}

export function Card({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`bg-white border border-line rounded-2xl ${className}`}>{children}</div>;
}
